import { AlgorithmTab } from '@/pages/Stats/StatsPage';

export function AlgorithmPage() {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-3xl font-semibold tracking-tight">Algorithm</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Opportunity scoring and replacement recommendation flow.
        </p>
      </div>
      <AlgorithmTab />
    </div>
  );
}
